import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery } from '../../utils/createAuthenticatedBaseQuery';
import { getTicketsApiBaseUrl } from '../../utils/runtimeConfig';

const apiBaseUrl = getTicketsApiBaseUrl();

export interface MobileRelease {
  platform: string;
  version: string;
  versionCode: number;
  releasedAt: string;
  downloadUrl: string;
}

/**
 * Web-only: the mobile app never calls the authorized download endpoint (it polls the anonymous
 * manifest with a plain fetch), so these definitions stay here rather than in @trackly/shared.
 */
export const mobileReleaseApi = createApi({
  reducerPath: 'mobileReleaseApi',
  baseQuery: createAuthenticatedBaseQuery(apiBaseUrl, 'Mobile Release API'),
  endpoints: (builder) => ({
    getMobileRelease: builder.query<MobileRelease, string>({
      query: (platform) => `mobile/release/${platform}/download`,
    }),
  }),
});

export const { useGetMobileReleaseQuery } = mobileReleaseApi;
